<script>
import countlyVue from '../../compat/vue-core';

const BaseStep = countlyVue.mixins.BaseContent.extend({
  data() {
    return {
      isValid: true,
      isStep: true,
    };
  },
});

export default BaseStep.extend({
  props: {
    validatorFn: { type: Function },
    id: { type: String, required: true },
    screen: {
      type: String,
      default: 'half',
      validator(value) {
        return ['half', 'full'].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      watchHandle: null,
    };
  },
  mounted() {
    this.watchHandle = this.$watch(
      () => this.$refs.observer.flags.valid,
      (newVal) => {
        this.isValid = newVal;
      },
    );
  },
  methods: {
    reset() {
      this.$refs.observer.reset();
    },
    touch() {
      this.$refs.observer.validate();
    },
  },
  computed: {
    isParentReady() {
      if (this.$parent.isToggleable) {
        return this.$parent.isOpened;
      }
      return true;
    },
  },
  beforeDestroy() {
    this.watchHandle(); // unwatch
  },
});
</script>
<template>
  <div
    v-if="isActive || alwaysMounted"
    :id="elementId"
    class="cly-vue-content"
    @keyup.enter="$emit('enter')"
  >
    <validation-observer ref="observer">
      <div
        v-show="isActive"
        v-if="isParentReady"
      >
        <slot />
      </div>
    </validation-observer>
  </div>
</template>
